import { Datoblock } from "./Types";

export interface LifestyleInfoQueryResponse {
    lifestyle?: {
        lifestyleInfoDescription: Datoblock;
        lifestyleInfoAlertBoxInfo: Datoblock;
    };
}

export const LifestyleInfoQuery = `
{
  lifestyle {
    lifestyleInfoDescription {
      value
    }
    lifestyleInfoAlertBoxInfo {
      value
    }
  }
}
`;
